export default "__VITE_ASSET__9506dc7a__"